import { render, staticRenderFns } from "./TablaReservaStock.vue?vue&type=template&id=1909e058"
import script from "./TablaReservaStock.vue?vue&type=script&lang=js"
export * from "./TablaReservaStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports